import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Wrapper from "../components/Wrapper";
import axios from "axios";
import { Button, Img } from "components";
import SuccessModal from "../Communication/SuccessModal";
import CommunicationModal from "../components/CommunicationModal";
import * as ModalR from 'react-modal';

const videoLinks = [
  {
    url: "https://soomuch.blob.core.windows.net/data-soomuch/DemoContent/AvatarVideos/homework.mp4",
  },
  // Additional videos can be added here
];


const customStylesRefer = {
    content: {
        top: "50%",
        left: "50%",
        right: "auto",
        bottom: "auto",
        marginRight: "-50%",
        transform: "translate(-50%, -50%)",
        width: "50rem", // Adjusted for responsiveness
        maxWidth: "90%", // Added to maintain a max width
        minHeight: "8rem",
        borderRadius: "1em",
        boxShadow: "0px 16px 32px 4px rgba(0, 0, 0, 0.15)",
        padding: "10px 0px",
        border: "0px",
    },
    overlay: {
        background: "rgba(0, 0, 0, 0.4)",
        zIndex: "999",
    },
    "@media (min-width: 768px)": {
        content: {
            width: "75%", // Adjusted for tablet view
        },
    },
    "@media (min-width: 1024px)": {
        content: {
            width: "55rem", // Original width for desktop view
        },
    },
};


const customStylesAskModal = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        width: '30rem',
        maxWidth: '80%',
        minHeight: '10rem',
        borderRadius: '1.5em',
        boxShadow: '0px 16px 32px 4px rgba(0, 0, 0, 0.15)',
        padding: '1.3em',
    },
    overlay: {
        background: 'rgba(0, 0, 0, 0.4)',
        zIndex: 999
    },
};


const HomeWork = () => {
  const navigate = useNavigate();
  const [position, setPosition] = useState(0);
  const [loader, setLoader] = useState(false);
  const [successModal, setSuccessModal] = useState<any>(false);
    const [confirmationModal, setConfirmationModal] = useState({ display: false, data: {} });
    const [communicationModal, setCommunicationModal] = useState({ display: false, DATA: {} });
    const [demoCampaignID, setDemoCampaignID] = useState<any>({});
    
    const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};

    const setTheSource = (source = "HW") => {
        if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            sessionStorage.setItem('demo_data', JSON.stringify({
                SOURCE: "COMM",
                OTP: "",
                IDS: [],
                ALREADY_PLAYED: []
            }));
        } else {
            setDemoCampaignID({ ...genrateDATA(), SOURCE: "HW" })
            sessionStorage.setItem('demo_data', JSON.stringify({
                ...genrateDATA(),
                SOURCE: "COMM",
            }));
        }
    }

  const handleVideoEnd = () => {
    if (position < videoLinks.length - 1) {
      setPosition((prev) => prev + 1);
    } else {
      // Option 1: Reset to first video
      setPosition(0);

      // Option 2 (optional): Pause or stop
      // setVideoEnded(true); // handle externally
    }
  };

  const genrateDATA = () => {
    let demoData: any = '';

    try {
      console.log("checking");
      demoData = JSON.parse(sessionStorage.getItem('demo_data')) || "";
    } catch (err) {
      console.log("err ", err);
    }
    return demoData
  }

      const checkAndSubmit = async () => {
        const form_data = JSON.parse(sessionStorage.getItem('form_data')) || {};
        try {
            setLoader(true);
            if (!!form_data?.MOBILE_NUMBER) {
                const isDataIsAlreadyThere = await axios.get(`https://stg.soomuch.ai/api/v1/master/demoCampaign/check?mobile_number=${form_data?.MOBILE_NUMBER}&source=HW`);
                if (isDataIsAlreadyThere?.data?.data?.exists) {
                    setConfirmationModal({ display: true, data: form_data })
                }/*  else if (!!form_data?.MOBILE_NUMBER) {
                    handleSubmit(form_data);
                }  */else {
                    setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
                }
            } else {
                setCommunicationModal({ display: true, DATA: genrateDATA() || JSON.parse(sessionStorage.getItem("demo_data")) })
            }
        } catch (err) {
            setSuccessModal(successModal => ({ key: "error", message: err?.message }));
        } finally {
            setLoader(false);
        }
    }

  const handleViewDemo = async () => {
    try {
      setLoader(true);
      if (genrateDATA()?.DEMO_CAMPAIGN_ID) {
        const payloadValue: any = {
          ...genrateDATA(),
          ALREADY_PLAYED: undefined,
          IDS: undefined,
          SOURCE: "HW"
        };

        const campaginDetailResponse = await axios.post(`https://stg.soomuch.ai/api/v1/master/demoCampaignDetail/insert`, payloadValue);

        if ([200, 201]?.includes(campaginDetailResponse?.data?.code)) {
          setSuccessModal(successModal => ({ key: "success", message: campaginDetailResponse?.data?.message }));
        } else {
          throw new Error(campaginDetailResponse?.data?.message)
        }
      } else {
        checkAndSubmit();
      }
    } catch (err) {
      setSuccessModal(successModal => ({ key: "error", message: err?.message }));
    } finally {
      setLoader(false);
    }
  }

   useEffect(() => {
          if (!genrateDATA()?.DEMO_CAMPAIGN_ID && !JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
              setTheSource();
          } else {
              setDemoCampaignID(genrateDATA())
          }
      }, []);

      

    const handleCommunicationModal = (e) => {
        setCommunicationModal(e)
        if (!!genrateDATA()?.DEMO_CAMPAIGN_ID && !!JSON.parse(sessionStorage.getItem("demo_data"))?.DEMO_CAMPAIGN_ID) {
            setDemoCampaignID(demoCampaignID => ({ ...genrateDATA(), SOURCE: "HW" }))
            // window.location.reload()
        }
    }

  return (
    <Wrapper
      wrapperTitleClasses={"mb-4"}
      title={<>Save a month of staff hours, every year.</>}
      description={"Automate daily homework follow-ups and eliminate manual reminders"}
      // innerBodyClasses={"pb-[0vh] pb-[0px]"}
      titleSize="text-[5vh]"
      videoLinks={videoLinks}
      body={<>
        {!!successModal?.key && <SuccessModal
          isOpen={successModal}
          onRequestClose={() => {
            setSuccessModal(false)
          }}
        />}
         {!!communicationModal?.display && <CommunicationModal
                    showModal={communicationModal}
                    customStyles={customStylesRefer}
                    setshowModal={(e) => handleCommunicationModal(e)}
                    handleVideoSaving={e => /* handleVideoSaving(e) */{}}
                    isHW={"HW"}
                />}
                {!!confirmationModal.display && <ModalR
                    isOpen={confirmationModal.display}
                    contentLabel="Example Modal"
                    style={customStylesAskModal}
                >
                    <div className="flex justify-between">
                        <h1 className="font-bold text-xl">Confirmation</h1>
                        <button onClick={() => setConfirmationModal({ display: false, data: {} })}>
                            <Img src="/images/Close.svg" alt="close" className="h-8" />
                        </button>
                    </div>
                    <p className="text-medium text-md text-neutral-70 my-[1.5em]">
                        The Homework demo for this number has already been completed. Are you sure you want to proceed with another demonstration?
                    </p>
                    <div className="flex justify-end">
                        <div className="flex gap-2">
                            <Button
                                size="sm"
                                type="button"
                                className="font-manropeSB rounded-lg"
                                onClick={() => {
                                    setConfirmationModal({ display: false, data: {} });
                                }}
                            >
                                No
                            </Button>
                            {loader ? <div>
                                <Img src="images/loader.gif" alt="loader" className="h-10" />
                            </div> : <button
                                onClick={() => {
                                    handleViewDemo();
                                }}
                                title="Send OTP"
                                type="button"
                                className={`bg-smd_blue-normal text-[white] py-2 px-4 rounded-2xl`}>
                                Yes
                            </button>}
                        </div>
                    </div>
                </ModalR>}
        <div className="flex justify-center">
          <div className="grid grid-cols-12 gap-y-1 gap-x-[3vh] w-full">
            <div className="col-span-4">
              <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal mb-2">
                The Problem
              </h2>
            </div>
            <div className="col-span-8">
              <h2 className="text-[3vh] text-center font-manropeB text-smd_blue-normal mb-2">
                The Solution
              </h2>
            </div>
            <ul className="col-span-4 bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl p-4 text-[black] space-y-[2vh] text-[2.3vh]">
              <li>
                Teachers <span className="font-manropeB tracking-wide">Spends 10 mins on</span> daily chasing homework updates. Assuming an average of 6 classes per teacher.
              </li>
              <li>
                <span className="font-manropeB tracking-wide">
                  For your school:
                </span>
              </li>
              <li>
                <span className="font-manropeB tracking-wide">
                  → 220 hours/year
                </span>{" "}
                per teacher
              </li>
              <li>
                <span className="font-manropeB tracking-wide">
                  → 1.25 months
                </span>{" "}
                extra learning for students
              </li>
              <li>
                <span className="font-manropeB tracking-wide">
                  → 4000 hrs operational inefficiency
                </span>{" "}
                per year
              </li>
              <li>
                <span className="font-manropeB tracking-wide">
                  → Up to 5 lakhs wasted annually
                </span>{" "}
                (for 20 teachers)
              </li>
            </ul>
            <div className="col-span-8 text-[black] text-[2.2vh] grid grid-cols-12 gap-[3vh]">
              <div className="col-span-6 flex flex-col gap-4">
                <div className="flex-1 bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl p-4 grid grid-cols-12 gap-2">
                  <div className="col-span-5">
                    <Img src="images/soomuch-demo/ManWithSpeaker.svg" alt="ManWithSpeaker" className="h-[18vh]" />
                  </div>
                  <div className="col-span-7 space-y-2">
                    <p className="text-[2.5vh] font-manropeB">Updates via Mobile <br /> App</p>
                    <p>Easy homework <br /> tracking on the go.</p>
                  </div>
                </div>

                <div className="flex-1 bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl p-4 grid grid-cols-12 gap-2">
                  <div className="col-span-5">
                    <Img src="images/soomuch-demo/WhatsAppInHand.svg" alt="WhatsAppInHand" className="h-[18vh]" />
                  </div>
                  <div className="col-span-7 space-y-2">
                    <p className="text-[2.5vh] font-manropeB">WhatsApp <br />Integration</p>
                    <p>No new apps—submit <br />updates via WhatsApp</p>
                  </div>
                </div>
              </div>
              <div className="col-span-6 grid grid-cols-2 gap-[3vh]">
                <div className="bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl flex flex-col overflow-clip">
                  <Img src="images/soomuch-demo/ManLookingAtCharts.svg" alt="ManLookingAtCharts" className="max-h-[30vh] object-cover" />
                  <div className="p-4">
                    <p className="text-[2.5vh] font-manropeB">Real-Time Teacher <br />Dashboard</p>
                    <p>Instant visibility into <br />student progress.</p>
                  </div>
                </div>
                <div className="bg-smd_white-normal shadow-2xl shadow-[lightgray] border border-[lightgray] rounded-3xl flex flex-col overflow-clip">
                  <Img src="images/soomuch-demo/Reminder.svg" alt="Reminder" className="max-h-[30vh] object-cover" />
                  <div className="p-4">
                    <p className="text-[2.5vh] font-manropeB">Automated Parent <br />Reminders</p>
                    <p>Never miss a deadline <br /> with auto-alerts.</p>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-span-12 text-center mt-2">
              <p className="text-[2vh]"><strong>Note:</strong> Assuming 500 student per school</p>
            </div> */}
            <div className="col-span-12 flex justify-center">
              {loader ? <Img src="images/loader.gif" alt="loader" className="h-10" /> :
                // <button title={!!genrateDATA()?.DEMO_CAMPAIGN_ID ? "View Demo" : "For demo please fill communication form"} disabled={!genrateDATA()?.DEMO_CAMPAIGN_ID} type="button" onClick={handleViewDemo} className="mt-[1vh] text-[2vh] py-3 px-4 bg-smd_blue-dark font-thin text-gray-200 rounded-xl font-manropeSB">Try Homework Demo</button>}
                <button title={"Try Homework Demo"} type="button" onClick={handleViewDemo} className="mt-[1vh] text-[2vh] py-3 px-4 bg-smd_blue-dark font-thin text-gray-200 rounded-xl font-manropeSB">Try Homework Demo</button>}
            </div>
          </div>
        </div>
      </>}
    />
  );
};

export default HomeWork; 